<template>
    <div id="apTrialBalanceAsAtDetail">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>

        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> AP Trial Balance As At Detail</div>
                    <div class="web-action-btn btn-groups text-right">
                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                            <i class="fp-export"></i> Export
                        </a>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content customer-ar-report">
                        <data-table-filter-config :moduleName="'apTrialBalanceAsAtDetail'" :allowSameFilter="'allow'"></data-table-filter-config>
                        <div class="data-table bg-white overflow-hidden">
                          <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                          <section class="data-table bg-white">
                                  <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange" :moduleName="'apTrialBalanceAsAtDetail'" :position="'top'">
                                  </custom-pagination>
                                  <vue-good-table
                                      ref="APTrialBalanceAsAtDetail"
                                      mode="remote"
                                      title="AP Trial Balance As At Detail"
                                      @on-page-change="onPageChange"
                                      @on-column-filter="onColumnFilter"
                                      @on-per-page-change="onPerPageChange"
                                      @on-sort-change="onSortChange"
                                      :totalRows="totalRecords"
                                      :columns="userColumns"
                                      :rows="rows"
                                      :pagination-options="{
                                          enabled: false,
                                          position: 'both',
                                          perPage: perPage,
                                          perPageDropdown:dropDownPerPage,
                                          dropdownAllowAll: false,
                                      }"

                                      :search-options="{
                                      enabled: false,
                                      }">
                                  </vue-good-table>
                                  <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange">
                                  </custom-pagination>
                          </section>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';
export default {
    name: "APTrialBalanceAsAtDetail",
    metaInfo() {
        return {
            title: "AP Trial Balance As At Detail | " +process.env.COPYRIGHT_NAME
        }
    },
    mixins:[commonMixins,dataTableMixins],
    data: () => ({
        firstLoad: 0,
        permissions: [],
        cantAccessPage: "",
        userColumns:[],
        columns: [
            {
                label:'Company',
                field:'company',
                fpFieldType:"option",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Company", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: ['000','001','002'],
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label:'Vendor Number',
                field:'vendor_code',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label:'Vendor Name',
                field:'vendor_name',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label:'Voucher Number',
                field:'voucher_number',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label:'Invoice Number',
                field:'bill_number',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label: "Invoice Date",
                field: "bill_date",
                hidden:false,
                fpFieldType:"custom_date",
                filterable: true,
            },
            {
                label: "Discount Date",
                field: "discount_date",
                hidden:false,
                fpFieldType:"custom_date",
                filterable: true,
            },
            {
                label: "Due Date",
                field: "due_date",
                hidden:false,
                fpFieldType:"custom_date",
                filterable: true,
            },
            {
                label:'Invoice Amount',
                field:'invoice_amount',
                fpFieldType:"integer",
                filterable: true,
                hidden:false,
                type:'number',
            },
            {
                label:'Payment Amount',
                field:'payment_amount',
                fpFieldType:"integer",
                filterable: false,
                hidden:false,
                type:'number',
                sortable:true
            },
            {
                label:'Balance Due',
                field:'balance_due',
                fpFieldType:"integer",
                filterable: false,
                hidden:false,
                type:'number',
                sortable:false
            },
            {
                label:'Current Amount',
                field:'current_amount',
                fpFieldType:"integer",
                filterable: false,
                hidden:false,
                type:'number',
                sortable:false
            },
            {
                label:'1-30 Days',
                field:'period_1',
                fpFieldType:"integer",
                filterable: false,
                hidden:false,
                type:'number',
                sortable:false
            },
            {
                label:'31-60 Days',
                field:'period_2',
                fpFieldType:"integer",
                filterable: false,
                hidden:false,
                type:'number',
                sortable:false
            },
            {
                label:'61-90 Days',
                field:'period_3',
                fpFieldType:"integer",
                filterable: false,
                hidden:false,
                type:'number',
                sortable:false
            },
            {
                label:'91-120 Days',
                field:'period_4',
                fpFieldType:"integer",
                filterable: false,
                hidden:false,
                type:'number',
                sortable:false
            },
            {
                label:'120+ Days',
                field:'period_5',
                fpFieldType:"integer",
                filterable: false,
                hidden:false,
                type:'number',
                sortable:false
            },
            {
                label:'Assignee Number',
                field:'assignee_number',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label:'Voucher Description',
                field:'voucher_description',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label:'Accounting Code',
                field:'accounting_code',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
                sortable:false
            },
            {
                label:'Voucher Type',
                field:'voucher_type',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label:'Hold Code',
                field:'hold_code',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
                sortable:false,
            },
            {
                label:'Vendor Type Code',
                field:'vendor_type',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label:'Remit Comment',
                field:'remit_comment',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label:'Note Description',
                field:'note_description',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label:'Voucher Comments',
                field:'voucher_comments',
                fpFieldType:"text",
                filterable: false,
                hidden:false,
                sortable:false
            },
            {
                label:'Note Author',
                field:'note_author',
                fpFieldType:"text",
                filterable: false,
                hidden:false,
                sortable:false
            },
            {
                label:'Note Create Date',
                field:'note_create_date',
                fpFieldType:"text",
                filterable: false,
                hidden:false,
                sortable:false
            },
            {
                label:'As of Year',
                field:'as_of_year',
                fpFieldType:"year",
                filterable: false,
                hidden:true,
                sortable:false,
                fpMandatory:true
            },
            {
                label:'As of Period',
                field:'as_of_period',
                fpFieldType:"period",
                filterable: false,
                hidden:true,
                sortable:false,
                fpMandatory:true
            },
            {
                label:'Select By Date',
                field:'by_date',
                fpFieldType:"option",
                filterable: false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Company", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: ['Yes','No'],
                    trigger: "enter" //only trigger on enter not on keyup
                },
                hidden:true,
                sortable:false,
                fpMandatory:true
            }
        ],
        rows: [],
        totalRecords: 0,
        loading:false,
        action:'list',
        batchProcess:0,
        batchNum:"",
    }),
    watch: {
        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'ap_trial_balance_as_at_detail_report') {
                        self.cantAccessPage = true;
                    }
                }
            }
        },
    },
    created: function() {
        this.serverParams.stopRequest = true;
    },
    mounted: function() {
        var self = this;

        self.getPermissions();
    },
    methods: {
        // exportReports: function() {
        //     var self = this;
        //     this.action = "export";
        //     this.loadList();
        // },
        loadList: function() {
            var self = this;
            var selectedYear = "";
            var selectedPeriod = "";
            if (self.serverParams.columnFilters.length > 0) {
                for(var i = 0;i < self.serverParams.columnFilters.length;i++) {
                    if (self.serverParams.columnFilters[i] != undefined) {
                        if (self.serverParams.columnFilters[i] != null) {
                            if (self.serverParams.columnFilters[i].columnId != null) {
                                if (self.serverParams.columnFilters[i].columnId.field != null) {
                                    if (self.serverParams.columnFilters[i].columnId.fpFieldType == "year") {
                                        selectedYear = self.serverParams.columnFilters[i].filterValue;
                                    }
                                    if (self.serverParams.columnFilters[i].columnId.fpFieldType == "period") {
                                        selectedPeriod = self.serverParams.columnFilters[i].filterValue;
                                    }
                                }
                            }
                        }
                    }
                }
            }

            if (selectedYear.trim() == "" || selectedPeriod.trim() == "") {
                return;
            }

            var fields = {
                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: self.serverParams.columnFilters,
                sort: self.serverParams.sort,
                action:self.action,
                year:selectedYear
            };

            self.firstLoad = 1;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/report/ap-trial-balance-as-at-detail",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {

                      if (self.action == "export" ||  self.action == "export_queue") {

                          if ( data.code == "201" ) {
                              alert(data.message);
                          } else {

                              if ( self.action == "export" ) {

                                  self.excel = data.content.web;
                                  var save = document.createElement("a");
                                  save.href = self.excel;
                                  save.download = data.content.web;
                                  save.target = "_blank";

                                  document.body.appendChild(save);
                                  save.click();
                                  document.body.removeChild(save);

                              } else {

                                  self.batchProcess = 1;
                                  self.batchNum = data.content;
                              }

                          }

                        self.action = "list";
                        self.loadList();

                        } else {
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                        }


                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'ap-trial-balance-as-at-detail')
                }
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/reports/APTrialBalanceAsAtDetail.vue